<!--Copy right - © 2024 tecera gmbh-->
<script>
    import { selected_device, current_device_data } from "../stores.js";

    export let is_mounted;

    let data_list;
    // creation of table rows
    $: if (is_mounted && $selected_device && $current_device_data) {
        data_list = $current_device_data.map((data) => {
            let row = [format_date(data.send_at)];
            $selected_device.channels.forEach((channel) => {
                let value = data[channel.name];
                if(value === null || value === undefined) {
                    value = "--";
                } else {
                if (channel.boolean_0) {
                    // displaying text instead of boolean
                    value = value === 0 ? channel.boolean_0 : channel.boolean_1;
                } else {
                    value = value.toFixed(3);
                }}
                row.push(value);
            });
            if (data.meta_data.length === 0) {
                row.push(null);
            } else {
                row.push(data.meta_data[0].rssi);
            }
            return row;
        });
    }

    function get_status(rssi) {
        if (rssi == null) {
            return "noData";
        }
        if (rssi > -100) {
            return "perfect";
        } else if (rssi > -107) {
            return "good";
        } else if (rssi > -115) {
            return "ok";
        } else {
            return "bad";
        }
    }

    function format_date(input_string) {
        // Create a Date object from the input string
        let date = new Date(input_string);

        // Format the Date object into the desired format
        let formattedString =
            date.getDate().toString().padStart(2, "0") +
            "." +
            (date.getMonth() + 1).toString().padStart(2, "0") +
            "." +
            date.getFullYear() +
            " " +
            date.getHours().toString().padStart(2, "0") +
            ":" +
            date.getMinutes().toString().padStart(2, "0");

        return formattedString;
    }
</script>

<div class="col-12 full">
    <div class="user_box2" style="overflow:auto;">
        {#if is_mounted && $selected_device && $current_device_data}
            <table class="table table-striped table-sm" id="data_table">
                <thead id="data_table_head">
                    <tr>
                        <th scope="col">Zeitstempel</th>
                        {#each $selected_device.channels as channel}
                            <th scope="col"
                                >{channel.measurand} ({channel.unit})</th
                            >
                        {/each}
                        <th scope="col">Verbindungsqualität (RSSI)</th>
                    </tr>
                </thead>

                <tbody id="customer_table_body">
                    {#each data_list as data}
                        <tr>
                            {#each data as row_data, idx}
                                {#if idx === 0}
                                    <th style="vertical-align: middle;"
                                        >{row_data}</th
                                    >
                                {:else if idx === data.length - 1}
                                    <td style="vertical-align: middle;"
                                        >{row_data
                                            ? row_data + " dBm"
                                            : row_data === 0
                                              ? 0
                                              : "Keine Daten"}
                                        <div
                                            class="d-md-flex d-inline justify-content-between flex-wrap flex-md-nowrap float-left pr-1 mr-2"
                                            style="vertical-align: middle;"
                                        >
                                            <div
                                                class="signal-bars sizing-box {get_status(
                                                    row_data,
                                                )}"
                                            >
                                                <div
                                                    class="bar first-bar"
                                                ></div><div
                                                    class="bar second-bar"
                                                ></div><div
                                                    class="bar third-bar"
                                                ></div><div
                                                    class="bar fourth-bar"
                                                ></div>
                                            </div>
                                        </div></td
                                    >
                                {:else}
                                    <td style="vertical-align: middle;"
                                        >{row_data}</td
                                    >
                                {/if}
                            {/each}</tr
                        >
                    {/each}
                </tbody>
            </table>
        {:else}
            <div id="loader" class="loader" style="top:25%;" />
        {/if}
    </div>
</div>
